import {ContentBlock} from "@/types";

export const content: ContentBlock[] = [

]
